import React, { useEffect, useRef, useState } from "react";
import { Ticket } from "../../../../models/Ticket";
import EAStepper from "../../../shared/Stepper/EAStepper";
import { useTranslation } from "react-i18next";
import useCalendarSale from "../../../CalendarSale/hooks/useCalendarSale";
import { DayPicker } from "react-day-picker";
import useLocaleByLanguage from "../../../../../utils/hooks/useLocaleByLanguage";
import { format } from "date-fns";
import EAButton from "../../../shared/Buttons/EAButton";
import { FaArrowRight } from "react-icons/fa";
import EAChoiceChip from "../../../shared/ChoiceChip/EAChoiceChip";

interface IProps {
  ticket: Ticket;
  onChangeDateFinish: () => void;
}

const SingleFutureTicketDateSelector: React.FC<IProps> = ({ ticket, onChangeDateFinish }) => {
  const { t } = useTranslation();
  const locale = useLocaleByLanguage();
  const [activeStep, setActiveStep] = useState(0);
  const selectedOrderRef = useRef<HTMLDivElement>(null);

  const [data, setData] = useState({ passIds: 0, exerciseIds: 0 });

  const { listaDat, getDaysAvailableByPassId, getExercisesByPassIds, selectedDate, exercise, getAssignByTicket } =
    useCalendarSale();

  const scrollToSelectedOrder = () => {
    if (selectedOrderRef.current) {
      selectedOrderRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    getDaysAvailableByPassId(ticket.objectId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeDate = () => {
    getAssignByTicket(data.passIds, data.exerciseIds, onChangeDateFinish);
  };

  return (
    <EAStepper
      hideSteps
      steps={[
        {
          label: "",
          content: (
            <div className="calendar">
              <DayPicker
                mode="single"
                locale={locale}
                selected={selectedDate}
                fromDate={new Date(ticket.validfrom)}
                toDate={new Date(ticket.validto)}
                onSelect={(date) => {
                  getExercisesByPassIds(date ?? new Date(), ticket.objectId);
                  scrollToSelectedOrder();
                }}
                showOutsideDays
                modifiersClassNames={{
                  selected: "my-selected",
                  today: "my-today",
                }}
                disabled={listaDat}
              />
              <div className="calendar-legend flex-start-center">
                <div className="calendar-legend-dot"></div>
                <b>{t("dostepne_terminy")}</b>
              </div>
              <EAButton
                title={t("wybierz_godzine")}
                fullWidth
                endIcon={<FaArrowRight />}
                onClick={() => setActiveStep(1)}
                disabled={!exercise[0]}
              />
            </div>
          ),
        },
        {
          label: "",
          content: (
            <div className="single-future-ticket-hours-container" ref={selectedOrderRef}>
              {exercise[0] && <b>{exercise[0].name}</b>}

              <div className="single-future-ticket-hours-wrapper">
                {exercise.map((item, index) => (
                  <EAChoiceChip
                    key={index}
                    label={`${format(item.startTime, "HH:mm")} - ${format(item.closeTime, "HH:mm")}`}
                    isSelected={item.objectId === data.exerciseIds}
                    onClick={() => {
                      setData({ passIds: ticket.objectId, exerciseIds: item.objectId });
                    }}
                    size="small"
                    showSelectedIcon={false}
                  />
                ))}
              </div>
              <EAButton
                title={t("zmien_termin")}
                fullWidth
                endIcon={<FaArrowRight />}
                onClick={() => onChangeDate()}
                disabled={!data.exerciseIds}
              />
            </div>
          ),
        },
      ]}
      activeStep={activeStep}
      onStepChange={(stepNumber) => setActiveStep(stepNumber)}
    />
  );
};

export default SingleFutureTicketDateSelector;
